﻿import './assets/styles/feedback.scss'
import jQuery from 'jquery'

import template from './assets/templates/feedback.mst'

import thumbsUp from './assets/images/thumbs-up.svg'
import thumbsDown from './assets/images/thumbs-down.svg'

function action (event, widget, params) {
  // Render action template
  var element = jQuery(jQuery.mustache(template, {
    sender: 'assistant',
    title: params.title,
    values: params.values,
    icons: {
      thumbsUp,
      thumbsDown
    },
    time: widget.getLocalDate()
  }))
  jQuery('.wgt-controls').one('submit', function () {
    jQuery('#feedback-action').remove()
  })
  // With one click event changes the handle fill color and disable the feedback buttons
  element.find('button').one('click', function () {
    var button = jQuery(this)
    jQuery('.wgt-controls').off('submit')
    switch (button.attr('class')) {
      case 'wgt-action-feedback-positive':
        button.css('cursor', 'not-allowed')
        button.find('svg path').css('fill', '#002eff')
        break
      case 'wgt-action-feedback-negative':
        button.css('cursor', 'not-allowed')
        button.find('svg path').css('fill', '#E8200C')
        break
    }
    button.siblings().prop('disabled', true)
    widget._send({
      type: 'text',
      payload: button.val()
    })
    widget._input.focus()
  })

  widget._log(element)
}

export default action
